import * as CookieConsent from 'vanilla-cookieconsent';

const GTM_ID = 'GTM-PKQBPDB4';
let gtmLoaded = false;

declare global {
  var dataLayer: Record<string, unknown>[] | undefined;
  function gtag(...args: unknown[]): void;
}

function loadGTM() {
  if (gtmLoaded) return;
  gtmLoaded = true;

  // Use globalThis directly as per SonarLint preference
  globalThis.dataLayer = globalThis.dataLayer ?? [];
  globalThis.dataLayer.push({ 'gtm.start': Date.now(), event: 'gtm.js' });

  const d = document;
  const f = d.getElementsByTagName('script')[0] as HTMLScriptElement | undefined;
  const j = d.createElement('script');

  j.async = true;
  j.src = 'https://www.googletagmanager.com/gtm.js?id=' + GTM_ID;

  if (f?.parentNode) {
    f.parentNode.insertBefore(j, f);
  } else {
    d.head.appendChild(j);
  }
}

/**
 * Update Google Consent Mode based on cookie acceptance
 */
function updateGtagConsent(granted: boolean) {
  if (typeof globalThis.gtag !== 'function') return;

  const state = granted ? 'granted' : 'denied';
  globalThis.gtag('consent', 'update', {
    'ad_storage': state,
    'ad_user_data': state,
    'ad_personalization': state,
    'analytics_storage': state,
  });
}

/**
 * Initialize Cookie Consent
 */
export const initCookieConsent = () => {
  void CookieConsent.run({
    guiOptions: {
      consentModal: {
        layout: 'box',
        position: 'bottom left',
        equalWeightButtons: true,
        flipButtons: false,
      },
      preferencesModal: {
        layout: 'box',
        position: 'right',
        equalWeightButtons: true,
        flipButtons: false,
      },
    },
    categories: {
      necessary: {
        readOnly: true,
      },
      analytics: {
        enabled: false,
      },
    },
    language: {
      default: 'nl',
      translations: {
        nl: {
          consentModal: {
            title: 'Wij gebruiken cookies',
            description:
              'Deze website gebruikt cookies om uw ervaring te verbeteren en voor analytische doeleinden.',
            acceptAllBtn: 'Alles accepteren',
            acceptNecessaryBtn: 'Alleen noodzakelijke',
            showPreferencesBtn: 'Voorkeuren beheren',
          },
          preferencesModal: {
            title: 'Cookie Voorkeuren',
            acceptAllBtn: 'Alles accepteren',
            acceptNecessaryBtn: 'Alleen noodzakelijke',
            savePreferencesBtn: 'Voorkeuren opslaan',
            closeIconLabel: 'Sluiten',
            sections: [
              {
                title: 'Noodzakelijke Cookies',
                description:
                  'Deze cookies zijn essentieel voor het correct functioneren van de website.',
                linkedCategory: 'necessary',
              },
              {
                title: 'Analytische Cookies',
                description:
                  'Deze cookies helpen ons te begrijpen hoe bezoekers de website gebruiken.',
                linkedCategory: 'analytics',
              },
            ],
          },
        },
      },
    },
    onFirstConsent: () => {
      if (CookieConsent.acceptedCategory('analytics')) {
        loadGTM();
        updateGtagConsent(true);
      }
    },
    onConsent: () => {
      if (CookieConsent.acceptedCategory('analytics')) {
        loadGTM();
        updateGtagConsent(true);
      } else {
        updateGtagConsent(false);
      }
    },
    onChange: () => {
      if (CookieConsent.acceptedCategory('analytics')) {
        loadGTM();
        updateGtagConsent(true);
      } else {
        updateGtagConsent(false);
      }
    },
  });
};


// Initialize on load
initCookieConsent();
